/**
 * Currency Formatting Utilities
 */

export class CurrencyFormatter {
  /**
   * Format price with currency symbol
   */
  static formatPrice(price: number, currency: string = 'USD', locale: string = 'en-US'): string {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(price);
    } catch (error) {
      return `${currency} ${price.toFixed(2)}`;
    }
  }

  /**
   * Format price without currency symbol
   */
  static formatPriceValue(price: number, decimals: number = 2): string {
    return price.toFixed(decimals);
  }

  /**
   * Parse price string to number
   */
  static parsePrice(priceString: string): number {
    const cleaned = priceString.replace(/[^0-9.-]+/g, '');
    return parseFloat(cleaned) || 0;
  }

  /**
   * Calculate discount percentage
   */
  static calculateDiscount(originalPrice: number, discountedPrice: number): number {
    if (originalPrice <= 0) return 0;
    return Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);
  }
}

